export enum DomainActiveRootStatusEnum {
  verified = 'verified',
  pending = 'pending',
  missing = 'missing',
}
